import * as moment from 'moment';

import { TimeUnit, DayOfWeek } from '../../../models';
import { IAlignmentStrategy } from './IAlignmentStrategy';

export class HourAlignmentStrategy implements IAlignmentStrategy {
    align(input: moment.Moment, beginTime: moment.Duration, interval: number, intervalTimeUnit: TimeUnit,
        dayOfWeek: DayOfWeek): moment.Moment {
        let result: moment.Moment = null;
        if (intervalTimeUnit === TimeUnit.Hour) {
            const originalTime = moment
                .duration(input.hour(), 'h')
                .add(input.minute(), 'm')
                .add(input.second(), 's')
                .add(input.millisecond(), 'ms');
            let hours = originalTime.hours();
            const minutes = beginTime.minutes();
            const seconds = beginTime.seconds();
            const diff = hours - beginTime.hours();
            const modulo = diff % interval;
            if (modulo !== 0) {
                if (diff < 0) {
                    hours = beginTime.hours();
                } else {
                    hours = beginTime.hours() + (Math.floor(diff / interval) + 1) * interval;
                }
            }
            let day = 0;
            if (hours >= 24) {
                hours = hours - 24;
                day = 1;
            }
            let updatedTime = moment.duration(day, 'd')
                .add(hours, 'h')
                .add(minutes, 'm')
                .add(seconds, 's');
            if (updatedTime < originalTime) {
                updatedTime = updatedTime.add(interval, 'h');
            }
            result = input.clone()
                .add(updatedTime.days(), 'd')
                .hour(updatedTime.hours())
                .minute(updatedTime.minutes())
                .second(updatedTime.seconds());

        }
        return result;
    }
}

